import { render } from "./CopyToClipboardText.vue?vue&type=template&id=b6e126ce&scoped=true"
import script from "./CopyToClipboardText.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardText.vue?vue&type=script&lang=js"

import "./CopyToClipboardText.vue?vue&type=style&index=0&id=b6e126ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e126ce"]])

export default __exports__